/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="pdf-document-wrapper">

    <PageLayoutPDF>
      <div class="pdf-section">
        <div class="pdf-header-title-area">
          <h1 class="pdf-title">COTIZACIÓN TÉCNICA:</h1>
          <h1 class="pdf-title">{{ data.formData.nombreProyecto }}</h1>
          <p style="margin:0; color:#666;">{{ data.formData.localidadProyecto }} , {{ data.formData.estado_proyecto }} ·
            {{ new Date().toLocaleDateString() }}</p>
        </div>

        <div class="info-cards-container">
          <div class="info-card">
            <h3 class="card-header-title">Información del contacto</h3>
            <div class="card-body">
              <div class="info-row"><span class="info-label">Código:</span><span class="info-value">{{
                data.formData.codigo_proyecto || 'PROY-0000' }}</span></div>
              <div class="info-row"><span class="info-label">Contacto:</span><span class="info-value">{{
                data.formData.nombre }} {{ data.formData.apellidoPaterno }}</span></div>
              <div class="info-row"><span class="info-label">Localidad:</span><span class="info-value">{{
                data.formData.localidadProyecto || data.formData.localidad }}, {{ data.formData.estado_proyecto
                  }}</span></div>
              <div class="info-row"><span class="info-label">Fuente:</span><span class="info-value">{{
                data.formData.fuente || 'Referido' }}</span></div>
              <div class="info-row"><span class="info-label">Teléfono:</span><span class="info-value">{{
                data.formData.telefono || '---' }}</span></div>
              <div class="info-row"><span class="info-label">Correo:</span><span class="info-value">{{
                data.formData.correo || '---' }}</span></div>
            </div>
          </div>

          <div class="info-card">
            <h3 class="card-header-title">Información del consumo</h3>
            <div class="card-body">
              <div class="info-row"><span class="info-label">Proyecto:</span><span class="info-value">{{
                data.formData.nombreProyecto }}</span></div>
              <div class="info-row"><span class="info-label">Tarifa:</span><span class="info-value">{{
                data.formData.tarifaCFE }}</span></div>
              <div class="info-row"><span class="info-label">Dirección:</span><span class="info-value">{{
                data.formData.direccion || '---' }}</span></div>
              <div class="info-row"><span class="info-label">Servicio:</span><span class="info-value">{{
                data.formData.numeroServicio || '---' }}</span></div>
              <div class="info-row"><span class="info-label">kWh Promedio:</span><span class="info-value">{{
                (data.averageKwh || 0).toLocaleString() }} kWh</span></div>
              <div class="info-row"><span class="info-label">Monto mensual:</span><span class="info-value">{{
                formatCurrency(data.averagePago) }}</span></div>
            </div>
          </div>
        </div>

        <div class="installer-quote-container" style="margin-top: 25px;">
          <div class="installer-header-box">
            <span class="badge-kwp">Sistema de {{ Number(data.formData.potenciaInstalar || 0).toFixed(2) }} kWp</span>
          </div>
          <div class="blue-box-border">
            <table class="table-installer-summary">
              <thead>
                <tr class="header-thin">
                  <th>CONCEPTO</th>
                  <th class="text-right">COSTO / VALOR</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Modulos Fotovoltaico ({{ data.formData.cantidadPaneles }} pzs)</td>
                  <td class="text-right">{{ formatCurrency(data.quoteTotals.precioPaneles) }}</td>
                </tr>
                <tr>
                  <td>Inversores ({{ data.formData.cantidadInversores }} pzs)</td>
                  <td class="text-right">{{ formatCurrency(data.quoteTotals.precioInversores) }}</td>
                </tr>
                <tr>
                  <td>Estructura</td>
                  <td class="text-right">{{ formatCurrency(data.quoteTotals.totalEstructura) }}</td>
                </tr>
                <tr>
                  <td>Material Fotovoltaico (Extras)</td>
                  <td class="text-right">{{ formatCurrency(data.quoteTotals.totalElectricoExtras) }}</td>
                </tr>
                <tr class="subtotal-line">
                  <td>Total Material FV</td>
                  <td class="text-right">{{ formatCurrency(data.quoteTotals.totalMaterialFV * 1.16) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <table class="table-installer-summary no-border">
            <tbody>
              <tr>
                <td>Mano de obra</td>
                <td class="text-right">{{ formatCurrency(data.quoteTotals.manoObra) }}</td>
              </tr>
              <tr>
                <td>Total Material Electrico + Margen</td>
                <td class="text-right">{{ formatCurrency(data.quoteTotals.totalConMargen10) }}</td>
              </tr>
              <tr class="direct-cost">
                <td>Costo Directo del Proyecto:</td>
                <td class="text-right">{{ formatCurrency(data.quoteTotals.totalCostoDirecto) }}</td>
              </tr>
              <tr class="gain-row">
                <td>+ Tu Utilidad / Ganancia</td>
                <td class="text-right">{{ formatCurrency(data.quoteTotals.ganaciaTotal) }}</td>
              </tr>
              <tr class="final-total-row">
                <td>PRECIO FINAL</td>
                <td class="text-right">{{ formatCurrency(data.quoteTotals.grandTotal) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </PageLayoutPDF>

    <PageLayoutPDF>
      <div class="pdf-section">
        <h2 class="historico-title">Consumo histórico</h2>
        <table class="historico-table-manual">
          <thead>
            <tr>
              <th class="text-left">Inicio</th>
              <th class="text-left">Término</th>
              <th class="text-right">Consumo (kWh)</th>
              <th class="text-right">Pago a CFE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data.consumoHistorico" :key="index">
              <td class="text-left">{{ item.inicio }}</td>
              <td class="text-left">{{ item.termino }}</td>
              <td class="text-right">{{ (item.kwh || 0).toLocaleString() }} kWh</td>
              <td class="text-right">{{ formatCurrency(item.pago) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="footer-row-anual">
              <td colspan="2" class="text-right font-bold">Total Anual</td>
              <td class="text-right font-bold">{{ totalKwh.toLocaleString() }} kWh</td>
              <td class="text-right font-bold">{{ formatCurrency(totalPago) }}</td>
            </tr>
            <tr class="footer-row-promedio">
              <td colspan="2" class="text-right font-blue">Promedio Mensual</td>
              <td class="text-right font-blue">{{ (data.averageKwh || 0).toLocaleString() }} kWh</td>
              <td class="text-right font-blue">{{ formatCurrency(data.averagePago) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </PageLayoutPDF>

    <PageLayoutPDF>
      <div class="pdf-section">
        <h2 class="section-title-header">Detalle del retorno de inversión</h2>
        <table class="roi-table-manual">
          <thead>
            <tr>
              <th class="text-left">Periodo</th>
              <th class="text-right">Consumo Hist.</th>
              <th class="text-right">Generación</th>
              <th class="text-right">Consumo Neto</th>
              <th class="text-right">Nuevo Pago</th>
              <th class="text-right">Pago Hist.</th>
              <th class="text-right">Ahorro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(year, idx) in data.roiDetail" :key="idx">
              <td class="text-left">{{ year.periodo }}</td>
              <td class="text-right">{{ (year.consumoHist || 0).toLocaleString() }} kWh</td>
              <td class="text-right">{{ (year.generacion || 0).toLocaleString() }} kWh</td>
              <td class="text-right">{{ (year.consumoNeto || 0).toLocaleString() }} kWh</td>
              <td class="text-right">{{ formatCurrency(year.nuevoPago) }}</td>
              <td class="text-right font-muted">{{ formatCurrency(year.pagoHist) }}</td>
              <td class="text-right font-bold text-green">{{ formatCurrency(year.ahorro) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </PageLayoutPDF>
  </div>
</template>

<script>
import PageLayoutPDF from './PageLayoutPDF.vue';

export default {
  name: 'PDFInstalador',
  components: { PageLayoutPDF },
  props: { data: Object },
  computed: {
    totalKwh() {
      return this.data.consumoHistorico?.reduce((acc, item) => acc + (Number(item.kwh) || 0), 0) || 0;
    },
    totalPago() {
      return this.data.consumoHistorico?.reduce((acc, item) => acc + (Number(item.pago) || 0), 0) || 0;
    }
  },
  methods: {
    formatCurrency(val) {
      return (val || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
    }
  }
};
</script>

<style scoped>
.pdf-section {
  padding: 10px 0;
}

.force-page-break {
  page-break-before: always;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.font-bold {
  font-weight: bold;
}

.font-blue {
  color: #29b9f6;
  font-weight: bold;
}

.pdf-header {
  border-bottom: 3px solid #29b9f6;
  margin-bottom: 15px;
  padding-bottom: 10px;
}

.pdf-title {
  font-size: 18px;
  color: #1a202c;
  font-weight: bold;
}

.info-cards-container {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-top: 10px;
}

.info-card {
  flex: 1;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background-color: #ffffff;
  padding-bottom: 10px;
  overflow: hidden;
}

.card-header-title {
  font-size: 14px;
  font-weight: 700;
  padding: 12px 15px;
  margin: 0;
  border-bottom: 1px solid #f1f5f9;
  color: #1a202c;
}

.card-body {
  padding: 10px 15px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 11px;
  border-bottom: 1px solid #f8fafc;
}

.info-label {
  color: #718096;
}

.info-value {
  color: #2d3748;
  font-weight: 600;
  text-align: right;
}

.installer-quote-container {
  width: 100%;
}

.badge-kwp {
  background: #29b9f6;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
}

.blue-box-border {
  border: 2px solid #29b9f6;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
}

.table-installer-summary {
  width: 100%;
  border-collapse: collapse;
}

.table-installer-summary td {
  padding: 7px 12px;
  font-size: 11px;
  color: #444;
}

.subtotal-line {
  border-top: 1px solid #29b9f6;
  font-weight: bold;
  background: #f0f9ff;
}

.direct-cost {
  background: #f1f1f1;
  font-weight: bold;
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.gain-row {
  color: #2e7d32;
  font-weight: bold;
  background: #f1f8e9;
}

.final-total-row {
  background: #f1f1f1;
  font-weight: bold;
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.final-total-row td {
  padding: 12px;
}

.historico-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.historico-table-manual {
  width: 100%;
  border-collapse: collapse;
}

.historico-table-manual th {
  padding: 12px;
  color: #718096;
  font-size: 12px;
  border-bottom: 1px solid #edf2f7;
  background-color: #fcfcfc;
}

.historico-table-manual td {
  padding: 10px 12px;
  font-size: 11px;
  border-bottom: 1px solid #f7fafc;
}

.footer-row-anual td {
  padding-top: 15px;
  border-top: 1px solid #edf2f7;
  background-color: #f8fafc;
}

.footer-row-promedio td {
  padding-top: 10px;
}


.roi-table-manual {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background-color: #ffffff;
}

.roi-table-manual th {
  background-color: #f1f5f9;
  color: #4a5568;
  font-size: 10px;
  padding: 8px 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  border-bottom: 1px solid #e2e8f0;
}

.roi-table-manual td {
  padding: 7px 10px;
  font-size: 9px;
  color: #2d3748;
  border-bottom: 1px solid #f1f5f9;
}

.roi-table-manual tr:nth-child(even) {
  background-color: #fafbfc;
}

.text-green {
  color: #2e7d32;
}

.font-muted {
  color: #a0aec0;
}

.font-bold {
  font-weight: 700;
}

.section-title-header {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  padding-bottom: 8px;
  margin-bottom: 15px;
  border-bottom: 2px solid #edf2f7;
}
</style>